import { render, staticRenderFns } from "./returnrejectioninfo-list.vue?vue&type=template&id=64fe8bde&scoped=true&"
import script from "./returnrejectioninfo-list.vue?vue&type=script&lang=ts&"
export * from "./returnrejectioninfo-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe8bde",
  null
  
)

export default component.exports